<template>
  <v-card outlined>
    <v-card-title>
      Sales Chart
    </v-card-title>
    <v-divider class="mx-4"/>
    <v-card-text>
      <im-bar-chart :chart-data="chart_data" :options="chart_options" :height="250"/>
    </v-card-text>
  </v-card>
</template>

<script>

  export default {

    components: {
      'im-bar-chart': () => import('@/components/Statistics/BarChart')
    },

    props: {
      sales: Object
    },

    computed: {

      chart_data() {
        return {
          labels: this.sales.labels,
          datasets: [
            {
              label: 'Vanzari (€)',
              data: this.sales.datasets.hotel.sales,
              borderColor: "#00B0FF",
              backgroundColor: "#00B0FF",
              yAxisID: 'sales',
            },
            {
              label: 'Costuri (€)',
              data: this.sales.datasets.hotel.costs,
              borderColor: "#00E676",
              backgroundColor: "#00E676",
              yAxisID: 'sales',
            }
          ]
        }
      },

      chart_options() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          fill: false,
          tooltips: {
            mode: 'index'
          },
          legend: {
            position: 'bottom'
          },
          scales: {
            yAxes: [
              {
                id: 'sales',
                type: 'linear',
                ticks: {
                  min: 0
                }
              }
            ]
          }
        }
      }

    }


  }
</script>